import {
  CloseCircle,
  InprogressIcon,
  PendingIcon,
  TickCircle,
} from '@/assets/icons';

export const getSeverity = (status) => {
  switch (status) {
    case 'WIP':
      return (
        <div className="flex flex-row w-36 h-full bg-[#7B68EE] bg-opacity-10 rounded-sm border border-[#D8BFD8]">
          <div className="text-[#663399] text-sm font-semibold m-auto whitespace-nowrap">
            WIP
          </div>
        </div>
      );
    case 'Rework-WIP':
      return (
        <div className="flex flex-row w-36 h-full bg-[#7B68EE] bg-opacity-10 rounded-sm border border-[#663399]">
          <div className="text-[#663399] text-sm font-semibold m-auto whitespace-nowrap">
            Rework-WIP
          </div>
        </div>
      );
    case 'Rework':
      return (
        <div className="flex flex-row w-36 h-full bg-[#7B68EE] bg-opacity-10 rounded-sm border border-[#663399]">
          <div className="text-[#663399] text-sm font-semibold m-auto">
            Rework
          </div>
        </div>
      );
    case 'Major Discrepancy':
      return (
        <div className="flex flex-row w-36 h-full bg-red-500 bg-opacity-10 rounded-sm border border-red-500">
          <div className="text-red-500 text-sm font-semibold m-auto whitespace-nowrap ">
            Major Discrepancy
          </div>
        </div>
      );
    case 'Minor Discrepancy':
      return (
        <div className="flex flex-row w-36 h-full bg-amber-500 bg-opacity-10 rounded-sm border border-amber-500">
          <div className="text-amber-500 text-sm font-semibold m-auto whitespace-nowrap">
            Minor Discrepancy
          </div>
        </div>
      );
    case 'QC-Open':
      return (
        <div className="flex flex-row w-36 h-full bg-blue-500 bg-opacity-10 rounded-sm border border-blue-500">
          <div className="text-blue-500 text-sm font-semibold m-auto whitespace-nowrap">
            QC-Open
          </div>
        </div>
      );
    case 'MovedToEntry':
      return (
        <div className="flex flex-row w-36 h-full bg-blue-500 bg-opacity-10 rounded-sm border border-blue-500">
          <div className="text-blue-500 text-sm font-semibold m-auto whitespace-nowrap">
            Moved to Entry
          </div>
        </div>
      );
    case 'Verified Clear':
      return (
        <div className="flex flex-row w-36 h-full bg-emerald-500 bg-opacity-10 rounded-sm border border-emerald-500">
          <div className="text-emerald-500 text-sm font-semibold m-auto whitespace-nowrap">
            Verified Clear
          </div>
        </div>
      );
    case 'Insufficiency':
      return (
        <div className="flex flex-row w-36 h-full bg-blue-500 bg-opacity-10 rounded-sm border border-blue-500">
          <div className="text-blue-500 text-sm font-semibold m-auto whitespace-nowrap">
            Insufficiency
          </div>
        </div>
      );
    case 'Unable to Verify':
      return (
        <div className="flex flex-row w-36 h-full bg-amber-500 bg-opacity-10 rounded-sm border border-amber-500">
          <div className="text-amber-500 text-sm font-semibold m-auto whitespace-nowrap">
            Unable to Verify
          </div>
        </div>
      );
    case 'Stop Check':
      return (
        <div className="flex flex-row w-36 h-full bg-amber-500 bg-opacity-10 rounded-sm border border-amber-500">
          <div className="text-amber-500 text-sm font-semibold m-auto whitespace-nowrap">
            Stop Check
          </div>
        </div>
      );
    case 'On-Hold':
      return (
        <div className="flex flex-row w-36 h-full bg-amber-500 bg-opacity-10 rounded-sm border border-amber-500">
          <div className="text-amber-500 text-sm font-semibold m-auto whitespace-nowrap">
            On-Hold
          </div>
        </div>
      );
    case 'Rejected':
    case 'QCRejected':
      return (
        <div className="flex flex-row w-36 h-full bg-red-500 bg-opacity-10 rounded-sm border border-red-500">
          <div className="text-red-500 text-sm font-semibold m-auto whitespace-nowrap">
            Negative
          </div>
        </div>
      );
    case 'Approved':
      return (
        <div className="flex flex-row w-36 h-full bg-emerald-500 bg-opacity-10 rounded-sm border border-emerald-500">
          <div className="text-emerald-500 text-sm font-semibold m-auto whitespace-nowrap">
            Approved
          </div>
        </div>
      );
    case 'Completed':
      return (
        <div className="flex flex-row w-36 h-full bg-emerald-500 bg-opacity-10 rounded-sm border border-emerald-500">
          <div className="text-emerald-500 text-sm font-semibold m-auto whitespace-nowrap">
            Completed
          </div>
        </div>
      );
    case 'InProgress':
      return (
        <div className="flex flex-row w-36 h-full bg-blue-500 bg-opacity-10 rounded-sm border border-blue-500">
          <div className="text-blue-500 text-sm font-semibold m-auto whitespace-nowrap">
            InProgress
          </div>
        </div>
      );
    case 'Pending':
      return (
        <div className="flex flex-row w-36 h-full bg-gray-300 bg-opacity-10 rounded-sm border border-gray-300">
          <div className="text-foreground text-sm font-semibold m-auto whitespace-nowrap">
            Pending
          </div>
        </div>
      );
    case 'BcaApproval':
      return (
        <div className="flex flex-row w-36 h-full bg-emerald-500 bg-opacity-10 rounded-sm border border-emerald-500">
          <div className="text-emerald-500 text-sm font-semibold m-auto whitespace-nowrap">
            BcaApproval
          </div>
        </div>
      );
    case 'BcaRejection':
      return (
        <div className="flex flex-row w-36 h-full bg-red-500 bg-opacity-10 rounded-sm border border-red-500">
          <div className="text-red-600 text-sm font-semibold m-auto whitespace-nowrap">
            BcaRejection
          </div>
        </div>
      );
    case 'Positive':
      return (
        <div className="flex flex-row w-36 h-full bg-green-500 bg-opacity-10 rounded-sm border border-green-500">
          <div className="text-green-500 text-sm font-semibold m-auto whitespace-nowrap">
            Positive
          </div>
        </div>
      );
    case 'Negative':
      return (
        <div className="flex flex-row w-36 h-full bg-red-500 bg-opacity-10 rounded-sm border border-red-500">
          <div className="text-red-500 text-sm font-semibold m-auto whitespace-nowrap">
            Negative
          </div>
        </div>
      );
    case 'Recommended':
      return (
        <div className="flex flex-row w-36 h-full bg-yellow-500 bg-opacity-10 rounded-sm border border-yellow-500">
          <div className="text-yellow-500 text-sm font-semibold m-auto whitespace-nowrap">
            Recommended
          </div>
        </div>
      );
    case 'Not Recommended':
      return (
        <div className="flex flex-row w-36 h-full bg-blue-500 bg-opacity-10 rounded-sm border border-blue-500">
          <div className="text-blue-500 text-sm font-semibold m-auto whitespace-nowrap">
            Not Recommended
          </div>
        </div>
      );
    case 'Failed':
      return (
        <div className="flex flex-row w-36 h-full bg-red-500 bg-opacity-10 rounded-sm border border-red-500">
          <div className="text-red-500 text-sm font-semibold m-auto whitespace-nowrap">
            Failed
          </div>
        </div>
      );
    case 'QCApproved':
      return (
        <div className="flex flex-row w-36 h-full bg-green-500 bg-opacity-10 rounded-sm border border-green-500">
          <div className="text-green-500 text-sm font-semibold m-auto whitespace-nowrap">
            QC Approved
          </div>
        </div>
      );

    case 'Could Not Verified':
      return (
        <div className="flex flex-row w-36 h-full bg-red-500 bg-opacity-10 rounded-sm border border-red-500">
          <div className="text-red-500 text-sm font-semibold m-auto whitespace-nowrap">
            Could Not Verified
          </div>
        </div>
      );
    case 'Details-Filled':
      return (
        <div className="flex flex-row w-36 h-full bg-blue-500 bg-opacity-10 rounded-sm border border-blue-500">
          <div className="text-blue-500 text-sm font-semibold m-auto whitespace-nowrap">
            Details Filled
          </div>
        </div>
      );
    case 'Not Assigned':
      return (
        <div className="flex flex-row w-36 h-full bg-red-500 bg-opacity-10 rounded-sm border border-red-500">
          <div className="text-red-500 text-sm font-semibold m-auto whitespace-nowrap">
            Not Assigned
          </div>
        </div>
      );
    case 'Reviewed Clear':
      return (
        <div className="flex flex-row w-36 h-full bg-emerald-500 bg-opacity-10 rounded-sm border border-emerald-500">
          <div className="text-emerald-500 text-sm font-semibold m-auto whitespace-nowrap">
            Reviewed Clear
          </div>
        </div>
      );
    case 'Review Error':
      return (
        <div className="flex flex-row w-36 h-full bg-red-500 bg-opacity-10 rounded-sm border border-red-500">
          <div className="text-red-500 text-sm font-semibold m-auto whitespace-nowrap">
            Review Error
          </div>
        </div>
      );
    case 'Verified Discrepancy':
      return (
        <div className="flex flex-row w-36 h-full bg-red-500 bg-opacity-10 rounded-sm border border-red-500">
          <div className="text-red-500 text-sm font-semibold m-auto whitespace-nowrap">
            Verified Discrepancy
          </div>
        </div>
      );
    case 'New':
      return (
        <div className="flex flex-row w-36 h-full bg-gray-300 bg-opacity-10 rounded-sm border border-gray-300">
          <div className="text-foreground text-sm font-semibold m-auto whitespace-nowrap">
            New
          </div>
        </div>
      );
    case 'Not Initiated':
      return (
        <div className="flex flex-row w-36 h-full bg-gray-300 bg-opacity-10 rounded-sm border border-gray-300">
          <div className="text-foreground text-sm font-semibold m-auto whitespace-nowrap">
            Not Initiated
          </div>
        </div>
      );
    case 'Initiated':
      return (
        <div className="flex flex-row w-36 h-full bg-blue-500 bg-opacity-10 rounded-sm border border-blue-500">
          <div className="text-blue-500 text-sm font-semibold m-auto whitespace-nowrap">
            Initiated
          </div>
        </div>
      );
    case 'Client Clarification Required':
      return (
        <div className="flex flex-row w-56 h-full bg-blue-500 bg-opacity-10 rounded-sm border border-blue-500">
          <div className="text-blue-500 text-sm font-semibold m-auto whitespace-nowrap">
            Client Clarification Required
          </div>
        </div>
      );
    case 'Closed Insufficiency':
      return (
        <div className="flex flex-row w-36 h-full bg-amber-500 bg-opacity-10 rounded-sm border border-amber-500">
          <div className="text-amber-500 text-sm font-semibold m-auto whitespace-nowrap">
            Closed Insufficiency
          </div>
        </div>
      );
    case 'Invited':
      return (
        <div className="flex flex-row w-36 h-full bg-gray-300 bg-opacity-10 rounded-sm border border-gray-300">
          <div className="text-foreground text-sm font-semibold m-auto whitespace-nowrap">
            Invited
          </div>
        </div>
      );

    default:
      return null;
  }
};

export const getVkycStatus = (status) => {
  switch (status) {
    case 'Completed':
      return (
        <div className="flex flex-row w-36 h-full bg-emerald-500 bg-opacity-10 rounded-sm border border-emerald-500">
          <div className="text-emerald-500 text-sm font-semibold m-auto whitespace-nowrap">
            Completed
          </div>
        </div>
      );
    case 'Rejected':
      return (
        <div className="flex flex-row w-36 h-full bg-red-500 bg-opacity-10 rounded-sm border border-red-500">
          <div className="text-red-500 text-sm font-semibold m-auto whitespace-nowrap">
            Rejected
          </div>
        </div>
      );
    case 'Approved':
      return (
        <div className="flex flex-row w-36 h-full bg-emerald-500 bg-opacity-10 rounded-sm border border-emerald-500">
          <div className="text-emerald-500 text-sm font-semibold m-auto whitespace-nowrap">
            Approved
          </div>
        </div>
      );
    case 'Pending':
      return (
        <div className="flex flex-row w-36 h-full bg-gray-300 bg-opacity-10 rounded-sm border border-gray-300">
          <div className="text-foreground text-sm font-semibold m-auto whitespace-nowrap">
            Pending
          </div>
        </div>
      );
    case 'Need To Review':
      return (
        <div className="flex flex-row w-36 h-full bg-orange-500 bg-opacity-10 rounded-sm border border-orange-500">
          <div className="text-orange-500 text-sm font-semibold m-auto whitespace-nowrap">
            Need To Review
          </div>
        </div>
      );
    default:
      return (
        <div className="flex flex-row w-36 h-full bg-gray-300 bg-opacity-10 rounded-sm border border-gray-300">
          <div className="text-foreground text-sm font-semibold m-auto whitespace-nowrap">
            {status}
          </div>
        </div>
      );
  }
};

export const status = [
  'Major Discrepancy',
  'Minor Discrepancy',
  'QC-Open',
  'Verified Clear',
  'Insufficiency',
  'Unable to Verify',
  'Stop Check',
  'Positive',
  'Negative',
  'Recommended',
  'Not Recommended',
  'Failed',
  'Could Not Verified',
  'On-Hold',
];
export const CheckStatus = ['Pending', 'InProgress', 'Completed', 'Rework'];
export const statusStyles = {
  All: 'bg-gray-300 text-black',
  Ongoing: 'bg-sky-100 border-sky-300 text-sky-600',
  WIP: 'bg-purple-100 border-purple-300 text-purple-600',
  'Rework-WIP': 'bg-purple-100 border-purple-300 text-purple-600',
  Rework: 'bg-purple-100 border-purple-300 text-purple-600',
  'Major Discrepancy': 'bg-red-100 border-red-300 text-red-600',
  'Minor Discrepancy': 'bg-amber-100 border-amber-300 text-amber-600',
  'QC-Open': 'bg-blue-100 border-emerald-300 text-blue-600',
  MovedToEntry: 'bg-blue-100 border-emerald-300 text-blue-600',
  'Verified Clear': 'bg-emerald-100 border-blue-300 text-emerald-600',
  Insufficiency: 'bg-blue-100 border-blue-300 text-blue-600',
  'Unable to Verify': 'bg-amber-100 border-amber-300 text-amber-600',
  'Stop Check': 'bg-yellow-100 border-gray-300 text-black',
  'On-Hold': 'bg-yellow-100 border-gray-300 text-black',
  Rejected: 'bg-red-100 border-red-300 text-red-600',
  OutDated: 'bg-orange-100 border-orange-300 text-orange-600',
  InTAT: 'bg-red-100 border-red-300 text-red-600',
  Approved: 'bg-emerald-100 border-emerald-300 text-emerald-600',
  Completed: 'bg-teal-200 border-teal-400 text-teal-700',
  InProgress: 'bg-blue-100 border-blue-300 text-blue-600',
  Pending: 'bg-gray-300 border-black text-black',
  BcaApproval: 'bg-emerald-100 border-emerald-300 text-emerald-600',
  BcaRejection: 'bg-red-100 border-red-300 text-red-600',
  Positive: 'bg-green-100 border-green-300 text-green-600',
  Negative: 'bg-red-100 border-red-300 text-red-600',
  Recommended: 'bg-yellow-100 border-yellow-300 text-yellow-600',
  'Not Recommended': 'bg-blue-100 border-blue-300 text-blue-600',
  Failed: 'bg-red-100 border-red-300 text-red-600',
  QCApproved: 'bg-green-100 border-green-300 text-green-600',
  QCRejected: 'bg-red-100 border-red-300 text-red-600',
  'Could Not Verified': 'bg-red-100 border-red-300 text-red-600',
  'Details-Filled': 'bg-blue-100 border-blue-300 text-blue-600',
  'Not Assigned': 'bg-red-100 border-red-300 text-red-600',
  Tester: 'bg-purple-100 border-purple-300 text-purple-600',
  'Client Coordinator': 'bg-blue-100 border-blue-300 text-blue-600',
  'Verification Coordinator': 'bg-green-100 border-green-300 text-green-600',
  'Verification Executive': 'bg-amber-100 border-amber-300 text-amber-600',
  'Data Entry': 'bg-red-100 border-red-300 text-red-600',
  QC: 'bg-yellow-100 border-yellow-300 text-yellow-600',
  Raised: 'bg-gray-300 text-black',
  Assigned: 'bg-gray-300 text-black',
  Resolved: 'bg-green-100 border-green-300 text-green-600',
  StopCheck: 'bg-yellow-100 border-gray-300 text-black',
  TotalReport: 'bg-teal-200 border-teal-400 text-teal-700',
  Invited: 'bg-gray-300 text-black',
  NeedReview: 'bg-orange-100 border-orange-300 text-orange-600',
  Assignee: 'bg-yellow-100 border-yellow-300 text-yellow-600',
};

export const darkStatusStyles = {
  'bg-gray-300': 'bg-black',
  'bg-sky-100': 'bg-sky-500',
  'bg-purple-100': 'bg-purple-500',
  'bg-red-100': 'bg-red-500',
  'bg-amber-100': 'bg-amber-500',
  'bg-blue-100': 'bg-blue-500',
  'bg-emerald-100': 'bg-emerald-500',
  'bg-teal-200': 'bg-teal-500',
  'bg-yellow-100': 'bg-yellow-500',
  'bg-orange-100': 'bg-orange-500',
  'bg-green-100': 'bg-green-500',
  'bg-black': 'bg-black',
};

// Available color combinations for dynamic role assignment
export const availableRoleColors = [
  'bg-sky-100 border-sky-300 text-sky-600',
  'bg-purple-100 border-purple-300 text-purple-600',
  'bg-red-100 border-red-300 text-red-600',
  'bg-amber-100 border-amber-300 text-amber-600',
  'bg-blue-100 border-blue-300 text-blue-600',
  'bg-emerald-100 border-emerald-300 text-emerald-600',
  'bg-teal-200 border-teal-400 text-teal-700',
  'bg-yellow-100 border-yellow-300 text-yellow-600',
  'bg-orange-100 border-orange-300 text-orange-600',
  'bg-green-100 border-green-300 text-green-600',
];

// Function to get a consistent color for a role name
export const getRoleColor = (roleIndex = 0) => {
  // Use role index to assign unique colors for first 10 roles, then repeat
  const colorIndex = roleIndex % availableRoleColors.length;
  return availableRoleColors[colorIndex];
};

export const Actions = [
  { label: 'CASE CREATED', value: 'case_created' },
  { label: 'CASE MOVED TO ENTRY', value: 'case_moved_to_entry' },
  { label: 'CASE DETAILS FILLED', value: 'case_details_filled' },
  { label: 'COMMENT ADDED', value: 'comment_added' },
  { label: 'TASK ASSIGNED', value: 'task_assigned' },
  { label: 'INSUFFICIENCY RAISED', value: 'insufficiency_raised' },
  { label: 'INSUFFICIENCY RESOLVED', value: 'insufficiency_resolved' },
  { label: 'TASK SUBMITTED', value: 'task_submitted' },
  { label: 'CASE STATUS CHANGED', value: 'case_status_changed' },
  { label: 'CASE ASSIGNED TO QC', value: 'case_assigned_to_qc' },
  { label: 'QC COMPLETED', value: 'qc_completed' },
  { label: 'CASE ATTACHMENTS ADDED', value: 'case_attachments_added' },
  { label: 'REWORK', value: 'rework' },
];

// Email Preferences Actions
export const EmailPreferencesActions = [
  { label: 'Case Created', value: 'case_created' },
  { label: 'Insufficiency Raised', value: 'insufficiency_raised' },
  { label: 'Insufficiency Resolved', value: 'insufficiency_resolved' },
  { label: 'Case Completed', value: 'case_completed' },
  { label: 'QC Completed', value: 'qc_completed' },
];

// POC Email Preferences Actions (separate from company email preferences)
export const POCEmailPreferencesActions = [
  { label: 'Case Created', value: 'case_created' },
  { label: 'Insufficiency Raised', value: 'insufficiency_raised' },
  { label: 'Insufficiency Resolved', value: 'insufficiency_resolved' },
  { label: 'Case Completed', value: 'case_completed' },
  { label: 'QC Completed', value: 'qc_completed' },
  {
    label: 'Candidate Data Entry Reminder',
    value: 'candidate_data_entry_reminder',
  },
];

export const getPriorityStatus = (status) => {
  switch (status) {
    case 'Critical':
      return (
        <div className="flex flex-row w-36 h-full bg-red-300 bg-opacity-10 rounded-full border border-red-500">
          <div className="text-red-500 text-sm font-semibold m-auto whitespace-nowrap">
            Critical
          </div>
        </div>
      );
    case 'High':
      return (
        <div className="flex flex-row w-36 h-full bg-orange-300 bg-opacity-10 rounded-full border border-orange-500">
          <div className="text-orange-500 text-sm font-semibold m-auto whitespace-nowrap">
            High
          </div>
        </div>
      );
    case 'Low':
      return (
        <div className="flex flex-row w-36 h-full bg-yellow-300 bg-opacity-10 rounded-full border border-yellow-500">
          <div className="text-yellow-500 text-sm font-semibold m-auto whitespace-nowrap">
            Low
          </div>
        </div>
      );
    case 'Lowest':
      return (
        <div className="flex flex-row w-36 h-full bg-green-300 bg-opacity-10 rounded-full border border-green-500">
          <div className="text-green-500 text-sm font-semibold m-auto whitespace-nowrap ">
            Lowest
          </div>
        </div>
      );

    default:
      return (
        <div className="flex flex-row w-36 h-full bg-blue-300 bg-opacity-10 rounded-full border border-blue-500">
          <div className="text-blue-500 text-sm font-semibold m-auto whitespace-nowrap">
            {status}
          </div>
        </div>
      );
  }
};

export const getStatusIcon = (status) => {
  switch (status) {
    case 'Pending':
      return (
        <div className="size-10 rounded-md flex items-center justify-center bg-secondary text-secondary-foreground">
          <PendingIcon />
        </div>
      );
    case 'Approved':
      return (
        <div className="size-10 rounded-md flex items-center justify-center bg-green-100">
          <TickCircle />
        </div>
      );
    case 'Rejected':
      return (
        <div className="size-10 rounded-md flex items-center justify-center bg-red-100">
          <CloseCircle />
        </div>
      );
    case 'InProgress':
      return (
        <div className="size-10 rounded-md flex items-center justify-center bg-blue-100">
          <InprogressIcon />
        </div>
      );
    case 'Need Review':
      return (
        <div className="size-10 rounded-md flex items-center justify-center bg-orange-100">
          <PendingIcon />
        </div>
      );
    default:
      return null;
  }
};
export const getStatusBadge = (status) => {
  const variants = {
    Approved: 'bg-green-500 text-white hover:bg-green-600',
    Rejected: 'bg-red-500 text-white hover:bg-red-600',
    InProgress: 'bg-blue-500 text-white hover:bg-blue-600',
    Pending: 'bg-gray-500 text-white hover:bg-gray-600',
  };
  return variants[status] || variants.Pending;
};
export const priorityFilters = [
  { name: 'Critical', value: 'Critical' },
  { name: 'High', value: 'High' },
  { name: 'Low', value: 'Low' },
  { name: 'Lowest', value: 'Lowest' },
];

export const verificationMode = [
  'Digital Verification',
  'Virtual Verification',
  'Offline Verification',
  'Written Verification',
  'Verbal Verification',
  'Physical Verification',
  'Email Verification',
];

export const remarkField = [
  'Verified Clear',
  'No Record Found',
  'Unable to Verify',
  'Stop',
  'Major Discrepancy',
  'Minor Discrepancy',
];

export const userEntityType = {
  BCA: 'BCA',
  Company: 'Company',
};

export const verifiesCompanyType = {
  Organization: 'Organization',
  User: 'User',
  EDDIndividual: 'EDDIndividual',
};

export const assignmentStatuses = [
  { name: 'Assigned', value: 'assigned' },
  { name: 'Unassigned', value: 'unassigned' },
];
export const caseTypes = [
  { name: 'Re-Initiated', value: 'reInitiated' },
  { name: 'Original', value: 'original' },
];
export const reviewStatuses = ['Reviewed Clear', 'Review Error'];
export const reviewErrorStatuses = ['Error Rectified'];
export const qcStatuses = ['Pending', 'InProgress', 'Completed'];
export const taskStatus = ['InProgress', 'Completed', 'Rework', 'OutDated'];
export const dateFilterStatus = [
  { name: 'Request Date', value: 'requestedDate' },
  { name: 'Deadline Date', value: 'deadlineDate' },
  { name: 'Completion Date', value: 'completionDate' },
];

export const productOptions = [
  { value: 'Personal loan', label: 'Personal loan' },
  { value: 'Home loan', label: 'Home loan' },
  { value: 'Vehicle finance', label: 'Vehicle finance' },
  { value: 'Auto loan', label: 'Auto loan' },
  { value: 'Two wheeler loan', label: 'Two wheeler loan' },
  { value: 'DSA', label: 'DSA' },
  { value: 'DST', label: 'DST' },
];

export const ACCEPTED_FILE_TYPES = [
  'text/csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
];
// Define status groups
export const approved = [
  'Approved',
  'Verified Clear',
  'Positive',
  'Recommended',
  'Not Recommended',
];
export const rejected = [
  'Rejected',
  'Negative',
  'Could Not Verified',
  'Failed',
  'Major Discrepancy',
  'Minor Discrepancy',
  'Verified Discrepancy',
];
export const stopCheck = ['Stop Check'];

export const statusGroups = {
  pending: ['Pending', 'New', 'Not Initiated', 'Invited', 'On-Hold'],
  approved,
  rejected,
  stopCheck,
  inProgress: [
    'InProgress',
    'MovedToEntry',
    'Details-Filled',
    'QC-Open',
    'QCApproved',
    'QCRejected',
    'Client Clarification Required',
    'Initiated',
  ],
  reworkWIP: ['Rework-WIP', 'Rework'],
  insufficiency: ['Insufficiency'],
  completed: [
    'Closed Insufficiency',
    'Unable to Verify',
    'Completed',
    ...approved,
    ...rejected,
    ...stopCheck,
  ],
};
